export const initProductCombination = () => {
  if (window.location.hash) {
    var hash = window.location.hash;
    hash = hash.substring(hash.lastIndexOf('-') + 1);
    if ($('.input-color:checked').data('color') != hash) {
      $('.input-color[data-color="' + hash + '"]')
        .prop('checked', true)
        .trigger('change');
    }
  }
};

export const initProductCombinationTab = () => {
  const combinationInputs = document.querySelectorAll('.product-variants .product-variants-list .input-container');

  if (combinationInputs.length) {
    combinationInputs.forEach(container => {
      container.addEventListener('keydown', event => {
        if (event.key === 'Enter') {
          const input = container.querySelector('input');
          if (input) {
            input.click();
          }
        }
      });
    });
  }
};
